module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "width": "680px"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickSave
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    attrs: {
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('div', {
    staticClass: "channel-list"
  }, [_c('div', {
    staticClass: "channel-first-row"
  }, _vm._l((_vm.firstRowChannels), function(item) {
    return _c('div', {
      key: item.channel,
      staticClass: "channel-first-item"
    }, [_c('div', {
      staticClass: "channel-row"
    }, [_c('span', {
      staticClass: "channel-name"
    }, [_vm._v(_vm._s(item.channelLabel))]), _vm._v(" "), _c('el-switch', {
      model: {
        value: (item.isOpen),
        callback: function($$v) {
          _vm.$set(item, "isOpen", $$v)
        },
        expression: "item.isOpen"
      }
    })], 1)])
  }), 0), _vm._v(" "), _vm._l((_vm.otherChannels), function(item) {
    return _c('div', {
      key: item.channel,
      staticClass: "channel-item channel-item-with-input"
    }, [_c('div', {
      staticClass: "channel-row"
    }, [_c('span', {
      staticClass: "channel-name"
    }, [_vm._v(_vm._s(item.channelLabel))]), _vm._v(" "), _c('el-switch', {
      model: {
        value: (item.isOpen),
        callback: function($$v) {
          _vm.$set(item, "isOpen", $$v)
        },
        expression: "item.isOpen"
      }
    })], 1), _vm._v(" "), (_vm.shouldRenderCodeInput(item)) ? _c('el-input', {
      staticClass: "channel-code-input",
      attrs: {
        "size": "small",
        "placeholder": "输入口令"
      },
      model: {
        value: (item.code),
        callback: function($$v) {
          _vm.$set(item, "code", $$v)
        },
        expression: "item.code"
      }
    }) : _vm._e()], 1)
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机系统"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择手机系统"
    },
    model: {
      value: (_vm.formData.osType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "osType", $$v)
      },
      expression: "formData.osType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Android",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "iOS",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "HarmonyOS",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用校区"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.allUnidFlag),
      callback: function($$v) {
        _vm.$set(_vm.formData, "allUnidFlag", $$v)
      },
      expression: "formData.allUnidFlag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全量")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), (_vm.formData.allUnidFlag === 1) ? _c('el-form-item', {
    attrs: {
      "label": "* 应用校区"
    }
  }, [_c('div', {
    staticClass: "campus-select-row"
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedCampus),
      callback: function($$v) {
        _vm.selectedCampus = $$v
      },
      expression: "selectedCampus"
    }
  }, _vm._l((_vm.campusDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.clickAddCampus
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.selectedCampusList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "card-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteCampus(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("一共 " + _vm._s(_vm.selectedCampusList.length) + " 个校区")])]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec21febc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/FengXiangTag.vue
// module id = 1139
// module chunks = 0